var _metadata, _defs, _desc;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNewGameButton(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 230,
    height: 55,
    viewBox: "0 0 230 55",
    id: "svg13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata19"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs17"
  })), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title2"
  }, "svg/nextButton") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title2"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc4"
  }, "Created with Sketch.")), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    transform: "translate(2,2)",
    id: "Button"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      mixBlendMode: "multiply",
      fill: "#000000",
      stroke: "#000000",
      strokeWidth: 2.5
    },
    id: "SHADOW",
    d: "M 180.89784,5.3219639 C 158.61609,6.9159203 17.192114,3.7919012 5.064152,13.817895 0.70944956,17.417858 -0.47160077,28.87689 0.15740838,36.111927 1.8687079,48.387672 18.480445,49.770256 32.970502,50.432485 c 18.390509,0.840488 151.645028,-0.04532 165.531188,-0.713309 14.88299,-1.46249 26.60132,-1.46249 26.38717,-20.937223 -0.05,-4.548352 -0.20322,-10.099496 -3.66623,-14.160494 -8.85354,-8.2167471 -26.187,-9.0490005 -40.32479,-9.2994951 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fab739",
      stroke: "#000000",
      strokeWidth: 2.5
    },
    id: "STROKE_99fb390a-b112-4495-90fb-e96524237ba6",
    d: "M 157.12086,2.4129716 C 132.46141,4.006928 17.192114,-2.2080988 5.064152,7.8178947 0.70944956,11.417858 -0.47160077,22.87689 0.15740838,30.111926 1.8687079,42.387672 18.480445,43.770256 32.970502,44.432485 c 18.390509,0.840488 152.596108,1.856834 166.482268,1.188849 14.88299,-1.46249 26.60132,-1.46249 26.38717,-20.937223 -0.05,-4.548352 -0.20322,-10.099496 -3.66623,-14.160494 -6.0003,-9.64336544 -50.91506,-7.8601508 -65.05285,-8.1106454 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#f5a623",
      strokeWidth: 1.5
    },
    id: "Path",
    d: "m 14,37.486443 c 14.489255,2.75165 187.81467,6.810623 200.3387,1.840502 6.11311,-2.425965 7.07954,-13.499926 4.33224,-21.711477"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#fbd764",
      strokeWidth: 1.5
    },
    id: "path9",
    d: "M 216.03167,13.625262 C 207.80925,8.3724423 188.17842,7.0830847 177.111,7.0211543 160.9534,6.7437911 34.533011,4.8071403 18.948178,7.8177418 10.765239,9.8939259 6.6735364,12.817888 5.5972802,20.4836 4.521024,28.149311 4.4606847,32.169938 9.2098843,35"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewGameButton);
export default __webpack_public_path__ + "static/media/newGameButton.19a5086cc2cb0c8e79218f9e634a8794.svg";
export { ForwardRef as ReactComponent };